import { Dialog, useNotifications } from '@ijoin/components';
import { usePostAdminRecordKeeperExportQueueReprocess } from '@ijoin/hooks';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

export const SubmissionLogReprocessDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  recordKeeperExportQueueId: null | string;
}) => {
  const notifications = useNotifications();
  const reprocess = usePostAdminRecordKeeperExportQueueReprocess({
    mutation: {
      onError: () => notifications.error('Failed to reprocess submission'),
      onSuccess: () => {
        props.onSuccess();
        props.onClose();
      }
    }
  });

  const onConfirm = () => {
    if (!props.recordKeeperExportQueueId) return;
    reprocess.mutate({ id: props.recordKeeperExportQueueId });
  };

  return (
    <Dialog
      data-testid='reprocessSubmissionDialog'
      isOpen={props.isOpen}
      onClose={props.onClose}>
      <DialogTitle variant='h3'>Reprocess submission</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Reprocess this submission? Status will be reset to Pending Export and
          the next export cycle will pick it up.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid='reprocessSubmissionBack'
          onClick={props.onClose}
          variant='outlined'>
          Back
        </Button>
        <Button
          color='warning'
          data-testid='confirmReprocessSubmission'
          disabled={reprocess.isPending || !props.recordKeeperExportQueueId}
          onClick={onConfirm}
          variant='contained'>
          Reprocess
        </Button>
      </DialogActions>
    </Dialog>
  );
};
